import axios from "axios";

export default {
    data: function () {
        return {
            mailSubject: '',
            mailBody: '',
            mailFrom: '',
            tos: [],
            ccs: [],
            bccs: [],
            attachments: [],
            tosInput: '',
            ccsInput: '',
            bccsInput: '',
            showCC: false,
            showBCC: false,
            disabled: false,
            uploading: false,
            files: [],
        }
    },
    methods: {
        removeLastEmail(data) {
            if (!this[data.target.dataset.ref+'Input'].length && this[data.target.dataset.ref].length) {
                if (!this[data.target.dataset.ref][this[data.target.dataset.ref].length - 1].locked)
                    this[data.target.dataset.ref].pop();
            }
        },
        removeEmail: function(array, index){
            this[array].splice(index, 1);
        },
        emailFromInput(array){
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (re.test(String(this[array+'Input']).toLowerCase())){
                this[array].push({
                    name: '',
                    email: this[array+'Input']
                });

                this[array+'Input'] = '';
            } else {

            }
        },
        removeAttachment: function(attachment, index){
            this.attachments.splice(index, 1);
            axios.delete(process.env.VUE_APP_API_URL + '/attachments/'+attachment.id);
        },
        addFiles(){
            this.$refs.files.click();
        },
        handleUpload: function(){
            this.disabled = true;

            const axiosConfig = {
                headers: {'Content-Type': 'multipart/form-data'}
            };

            let uploadedFiles = this.$refs.files.files;

            for(let i = 0; i < uploadedFiles.length; i++ ){
                this.files.push( uploadedFiles[i] );
            }

            let formData = new FormData();
            formData.append('folder', 'attachments');

            for (let x = 0; x < this.files.length; x++ ){
                let file = this.files[x];
                formData.append('files[' + x + ']', file);
            }

            this.uploading = true;

            formData.append('model', this.model);
            formData.append('id', this.id);
            formData.append('group', 'email-attachments');

            axios.post(process.env.VUE_APP_API_URL + '/upload', formData, axiosConfig).then(response => {
                setTimeout(() => {
                    // reset the upload properties
                    this.resetUpload();

                    if(response.data.success === true){
                        response.data.data.forEach(attachment => {
                            this.attachments.push(attachment);
                        });

                        // success
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Success',
                            text: 'Upload Successful',
                            duration: 5000
                        });
                    } else {
                        // notify the error
                        this.$notify({
                            group: 'main',
                            type: 'error',
                            title: 'Error',
                            text: 'Upload Error',
                            duration: 5000
                        });
                    }
                }, parseInt(this.delay));
            }).catch(() => {
                this.resetUpload();

            });
        },
        resetUpload: function(){
            this.uploading = false;
            this.percentCompleted = 0;
            this.files = [];
            this.disabled = false;
        },
    },
    mounted() {
        if (this.to && this.to !== ''){
            if (this.to instanceof Object){
                this.tos.push(this.to);
            } else if (this.to.isArray){
                this.to.forEach(t => {
                    this.tos.push(t);
                });
            } else if (this.to instanceof String){
                this.tos.push({
                    name: null,
                    email: this.to
                })
            }
        }
    },
    beforeMount() {
        const user = this.$store.getters.user;
        const signature = '<table style="padding:0; margin:10px 0; border:none; width: 100%;">' +
            '                <tbody>' +
            '                    <tr>' +
            '                        <td style="vertical-align:middle; text-align: center; padding:0 7px 0 0; width: 18%;">' +
            '                            <img alt="Niftee Group" width="100%" src="https://fasperth-dev.s3-ap-southeast-2.amazonaws.com/FAS-logo.png" />' +
            '                        </td>' +
            '                        <td style="border-left:3px solid #922C49; padding:7px 0 0 10px">' +
            '                            <div style="font-weight:bold;color:black">'+ user.first +' '+ user.last +'</div>' +
            '                            <div style="font-weight:normal;margin-bottom:10px">' +
            '                                <span style="color:#922C49"><strong>'+ user.position +'</strong></span>' +
            '                            </div>' +
            '                            <div style="font-weight:normal;color:#808080;margin-bottom:10px">' +
            '                                <span style="color:#922C49"><strong>M:</strong></span> <a href="tel:'+ user.mobile +'" rel="nofollow" style="text-decoration:none;"><span style="color:rgb( 128 , 128 , 128 )">'+ user.mobile +'</span></a>' +
            '                                <span style="color:#969696">|</span>' +
            '                                <span style="color:#922C49"><strong>E:</strong></span> <a href="mailto:'+ user.emailProvider.email +'" rel="nofollow" style="text-decoration:none;color:rgb( 128 , 128 , 128 )">'+ user.emailProvider.email +'</a>' +
            '                                <span style="color:#969696">|</span>' +
            '                                <span style="color:#922C49"><strong>W:</strong></span> <a href="https://www.fasperth.com.au/?utm_source=signature&amp;utm_medium=email&amp;utm_campaign=direct" rel="nofollow" style="color:#808080;text-decoration:none">www.fasperth.com.au</a>' +
            '                            </div>' +
            '                            <div style="color:#808080">' +
            '                                FAS Perth' +
            '                                <span style="color:#969696">|</span>' +
            '                                <span style="color:#922C49"><strong>ABN:</strong></span> 99 140 631 189' +
            '                            </div>' +
            '                            <div style="font-weight:normal;color:black;margin-bottom:5px">' +
            '                                <span style="color:#808080">22 Baling Street, Cockburn Central, WA 6164</span>' +
            '                            </div>' +
            '                        </td>' +
            '                    </tr>' +
            '                </tbody>' +
            '            </table>';

        this.mailBody = this.content + '<p>Regards,</p>' + signature;
    },
}
